import some from "lodash/some"

const EXCLUDED_PATHS = [
  "/jautajumu-banka",
  "/mani-testi"
]

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$router.afterEach((to, from) => {
    try {
      if (to.path.includes("/login") || from.path.includes("/login")) {
        window.destroyBeacon()
        window.initBeacon()
      }

      if (some(EXCLUDED_PATHS, (subpath) => from.path.includes(subpath) && !to.path.includes(subpath))) {
        window.initBeacon()
      }

      console.log("[HELPSCOUT] Refreshing Beacon and trigger page view")
      const title = `${String(to.name)} (${document.title})`
      window.Beacon("suggest")
      console.log("[HELPSCOUT] page-viewed", title)
      window.Beacon("event", { type: "page-viewed", url: document.location.href, title })
    } catch (e) {
      console.log("[HELPSCOUT] Error refreshing Beacon", e.message)
    }
  })
})
